import React from 'react';
import { Flame } from 'lucide-react';
import { DeploymentRequest } from '../../types';
import { computeDeploymentStreak } from '../../utils/deploymentAnalytics';

interface DeploymentStreakTileProps {
  deployments: DeploymentRequest[];
}

const DeploymentStreakTile: React.FC<DeploymentStreakTileProps> = ({ deployments }) => {
  const streak = computeDeploymentStreak(deployments);

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-orange-500 to-rose-600 rounded-lg shadow-md shadow-orange-200 p-6 text-white h-full flex flex-col justify-between">
      <div className="pointer-events-none absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/10" />
      <div className="flex items-center gap-2">
        <div className="p-1.5 rounded-lg bg-white/15">
          <Flame className="w-4 h-4" />
        </div>
        <p className="text-sm text-orange-50">Current weekday deployment streak</p>
      </div>
      <p className="text-4xl font-bold mt-3">{streak} {streak === 1 ? 'day' : 'days'}</p>
      <p className="text-xs text-orange-100 mt-2">Consecutive weekdays with at least one successful deployment</p>
    </div>
  );
};

export default DeploymentStreakTile;
